import { AppDispatch } from '../../Store'
import {
  FieldsToModify,
  IFieldTitleValue,
  IKeyValue,
  moduleType,
  scheduleTimeType,
} from '../CommonListHeadingModal'
import { IPinnedItemDetail, IPinnedItemDetailInRedux } from '../DataCategoryUtils'

export interface IContainerInstanceState {
  containerDefinitionDetails: { [key: string]: any }
  containerDetails: { [key: string]: any }
  parentContainerDetail: { [key: string]: any }
  itemDetail: { [key: string]: any[] }
  containerPinnedItems: IPinnedItemDetailInRedux
  masterLayoutItemInfo: any[]
}

export const initialContainerInstanceState: IContainerInstanceState = {
  containerDefinitionDetails: {},
  containerDetails: {},
  parentContainerDetail: {},
  itemDetail: {},
  containerPinnedItems: {
    ids: [],
    position: [],
    items: [],
  },
  masterLayoutItemInfo: [],
}

export interface IManageContainerSlice {
  containersById: { [containerId: string]: IContainerInstanceState }
}

export interface IContainerManual {
  isFormValid?: (val: boolean) => void
  isEditableContainer?: boolean
  layoutTitle?: string
  formData?: any
  formFieldValue?: IFieldTitleValue[]
  conditionalFieldsToShow?: string[]
  isFormSaved?: boolean
  updateIsFormSaved?: (val: boolean) => void
  handleEditParameterBtnClick: () => void
  setShowSecondaryCta?: (val: boolean) => void
  setSecondaryCtaClicked?: (val: boolean) => void
  setShouldDisableSecondaryCta?: (val: boolean) => void
  secondaryCtaClicked?: boolean
  selectedTab: IKeyValue
}
export type containerModuleType = Exclude<moduleType, 'container'>
export interface TitleFormSectionProps {
  layout: string
  pageType: string
  formContext: any
  containerFormData: any
  viewData: any
  setSelectedAssetTypes: (value: IKeyValue[]) => void
  conditionalFieldsToShow?: string[]
  fieldsToModify: FieldsToModify
  formFieldValue?: IFieldTitleValue[]
}
export interface AssetDetailsTableProps {
  module: containerModuleType
  contentListDetail: any[]
  checkedIconDisabled: boolean
  pageType: string | undefined
  layout: string
  containerDefinitionInfo: any
  replaceAndAddedItem: Set<string>
  handleAccordionDelete: (id: number | string, module: containerModuleType) => void
  toggleItem: (module: containerModuleType, id: string) => void
  isItemChecked: (module: containerModuleType, id: string) => boolean
  setReplaceAndEditItemData: any
  setIsDialogOpen: any
  setModalSelectedTab: any
  imageNodesList: any[]
  dispatch: AppDispatch
  itemDetailFromRedux: any
  pinnedItemPositions: Set<number>
  containerId: string | undefined
  setEditItemDetail: any
  setSelectedItemModule: any
  containerErrors: any
  setScheduleItemModal: any
  handleAdditionalParameterClick: (id: string, item: any) => void
}
export interface ItemDetailsSectionProps {
  module: containerModuleType
  modalTabList: string[]
  layout: string
  selectedItemDetail: any
  checkedItemList: any
  pageType: string | undefined
  isItemCtaDisabled: (module: containerModuleType) => boolean
  isEditableContainer: boolean
  handleRemoveAll: (module: containerModuleType) => void
  areAllItemsChecked: any
  clearAllItems: any
  selectAllItems: any
  handleAdd: (module: containerModuleType) => void
  setShowSecondaryCta: any
  collapsedSections: Record<containerModuleType, boolean>
  setCollapsedSections: React.Dispatch<React.SetStateAction<Record<containerModuleType, boolean>>>
  visibleCount: Record<containerModuleType | 'pinned', number>
  displayItemToList: (module: containerModuleType, keyToCheck: string) => JSX.Element
  containerErrors: any
  handleScheduleClick: any
  pinnedItemsInfoList: IPinnedItemDetail
  itemDetailFromRedux: any
  setScheduleItemModal: any
  setSelectedItemModule: any
  isLoadingMore: any
  isPinnedSectionCollapsed: boolean
  setIsPinnedSectionCollapsed: React.Dispatch<React.SetStateAction<boolean>>
  containerModalComputedStyle: string
}
export interface ItemDetailsRowProps extends AssetDetailsTableProps {
  item: any
  index: number
  isItemPinned?: boolean
}

export interface HandleScheduleClick {
  itemLists: Record<string, any[]>
  data: Record<string, any>
  type: scheduleTimeType
  dispatch: AppDispatch
  containerId?: string
  contentId?: number
  contentMongoId?: string
}

export interface ChildContainerListingProps {
  entryPoint?: string
}
export type togglePopup = 'enable' | 'disable' | 'edit'
export interface RowSegment {
  key: number
  value: string
  segmentUrl: string
  segmentId: string
  irisSegmentStatus: boolean | null
  isTrayRankingEnabled: boolean
  pinCount: number
}
export type TrayRankingDialog = {
  open: boolean
  rowId: string
  enabling: togglePopup
  containerTitle: string
  containerId: string
  contentDocId: string
  rowSegments: RowSegment[]
  item: any
}
